/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { typography } from '../../shared/theme/typography';
import { ticketColors } from '../../shared/theme/ticketColors';
import { spacing } from '../../shared/theme/spacing';

type Props = {
  message: string | null;
  testID?: string;
};

/** Una línea cuando Confirmar está bloqueado por validación de pago. */
export function ExpensePaymentSubmitHint({ message, testID = 'gastos.payment.submit-hint' }: Props) {
  if (!message) return null;
  return (
    <View style={styles.wrap} accessibilityLiveRegion="polite">
      <Text style={styles.text} testID={testID}>
        {message}
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  wrap: {
    width: '100%',
    paddingHorizontal: spacing.xs,
  },
  text: {
    ...typography.caption,
    color: ticketColors.warn,
    fontWeight: '600',
    lineHeight: 18,
  },
});
